<template>
  <v-app
  :class="[$router.currentRoute.name]"
  id="app"
  >
    <Menu v-bind:menuItems="siteData.menu" />
    <v-content>
      <component v-bind:is="currentComponent"></component>
    </v-content>
    <Footer v-bind:text="siteData.footerText" v-bind:links="siteData.footerLinks" />
  </v-app>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";

import siteData from "./site-data";
export default {
  name: 'App',
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  components: {
    Menu,
    Footer
  },
  data: () => ({
    currentComponent: 'router-view',
    siteData: siteData
  }),
  methods: {
  },
};
</script>

